/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HeartsDropdownContainer_user$ref: FragmentReference;
declare export opaque type HeartsDropdownContainer_user$fragmentType: HeartsDropdownContainer_user$ref;
export type HeartsDropdownContainer_user = {|
  +id: string,
  +vcCurrent: ?number,
  +level: ?number,
  +heartsUntilNextLevel: ?number,
  +vcDonatedAllTime: ?number,
  +numUsersRecruited: ?number,
  +tabsToday: ?number,
  +$refType: HeartsDropdownContainer_user$ref,
|};
export type HeartsDropdownContainer_user$data = HeartsDropdownContainer_user;
export type HeartsDropdownContainer_user$key = {
  +$data?: HeartsDropdownContainer_user$data,
  +$fragmentRefs: HeartsDropdownContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "HeartsDropdownContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vcCurrent",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "level",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "heartsUntilNextLevel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vcDonatedAllTime",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "numUsersRecruited",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "tabsToday",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd4b70b25f7a77591d61fad11d1bd7430';
module.exports = node;
